import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { useStoreManagementStore } from "@/store/storeManagementStore";
import { StoreSelector } from "@/components/menu/StoreSelector";
import { ActivityLogTabs } from "@/components/activity/ActivityLogTabs";
import { useAuthStore } from "@/store/authStore";
import { useTranslation } from "react-i18next";

const ActivityLog = () => {
  const { t } = useTranslation();
  const { user } = useAuthStore();
  const { stores, selectedStoreId } = useStoreManagementStore();

  useEffect(() => {
    useStoreManagementStore.getState().fetchStores();
  }, []);

  const isStoreSelectionDisabled = user?.role === "staff";

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {t("activityLog")}
          </h1>
          <p className="text-muted-foreground mt-1">{t("trackActivities")}</p>
        </div>
      </div>

      {selectedStoreId && (
        <Card>
          <CardHeader className="pb-3">
            <CardTitle>{t("recentActivity")}</CardTitle>
            <CardDescription>{t("trackStoreActivities")}</CardDescription>
          </CardHeader>
          <CardContent>
            <ActivityLogTabs storeId={selectedStoreId} />
          </CardContent>
        </Card>
      )}

      {!selectedStoreId && (
        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>{t("selectStore")}</CardTitle>
            <CardDescription>{t("viewStoreActivity")}</CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center p-6">
            <StoreSelector
              value={selectedStoreId || ""}
              onValueChange={() => {}}
              disabled={isStoreSelectionDisabled}
              className="w-full max-w-xs"
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default ActivityLog;
